import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results", "clientId", "clientInfo"]

  connect() {
    this.timeout = null
  }

  search() {
    clearTimeout(this.timeout)

    const query = this.inputTarget.value.trim()

    if (query.length < 2) {
      this.resultsTarget.innerHTML = ""
      return
    }

    this.timeout = setTimeout(() => {
      fetch(`/api/clients?q=${encodeURIComponent(query)}`, {
        headers: {
          "Accept": "application/json"
        }
      })
        .then(response => response.json())
        .then(clients => {
          this.showResults(clients)
        })
        .catch(error => {
          console.error("Error searching clients:", error)
        })
    }, 300)
  }

  showResults(clients) {
    if (clients.length === 0) {
      this.resultsTarget.innerHTML = '<div class="list-group-item text-muted">No se encontraron clientes</div>'
      return
    }

    this.resultsTarget.innerHTML = clients.map(client => `
      <button type="button"
              class="list-group-item list-group-item-action"
              data-action="click->client-search#selectClient"
              data-client-id="${client.id}"
              data-client-name="${client.name}"
              data-client-document-type="${client.document_type}"
              data-client-document-number="${client.document_number}"
              data-client-address="${client.address}">
        <strong>${client.name}</strong><br>
        <small>${client.document_type}: ${client.document_number}</small>
      </button>
    `).join("")
  }

  selectClient(event) {
    event.preventDefault()
    const button = event.currentTarget

    const clientId = button.dataset.clientId
    const name = button.dataset.clientName
    const documentType = button.dataset.clientDocumentType
    const documentNumber = button.dataset.clientDocumentNumber
    const address = button.dataset.clientAddress

    this.clientIdTarget.value = clientId
    this.inputTarget.value = name

    this.clientInfoTarget.innerHTML = `
      <div class="alert alert-light">
        <strong>${name}</strong><br>
        ${documentType}: ${documentNumber}<br>
        ${address}
      </div>
    `

    this.resultsTarget.innerHTML = ""
  }

  // Hide results when clicking outside
  hideResults(event) {
    if (!this.element.contains(event.target)) {
      this.resultsTarget.innerHTML = ""
    }
  }
}
